module.exports = __webpack_public_path__ + "img/map-qld.6c6cf1f7.png";